interface Date {
    CompareDate(toDate?: Date | null): boolean;
    CallMe(): void;
    toUTCTime(): Date;
    addUtcDay(day:number) : Date;
}

Date.prototype.CompareDate = function (toDate?: Date): boolean {
    const self = this;
    if (self == null || toDate == undefined || toDate == null || toDate == undefined) return true;
    return self <= toDate;
}

Date.prototype.toUTCTime = function (): Date {
    var date = this;
    var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    return JSON.stringify(new Date(now_utc)).jsonTo<Date>();
}

Date.prototype.addUtcDay = function(day:number) : Date {
    var date = this;
    date.setDate(date.getUTCDate() + day);
    return new Date(date);
}